// Select all elements with the class 'inline-deferred-iframe'
const inlineDeferredIframeWrappers = document.querySelectorAll('.inline-deferred-iframe');

// Loop through each element and add a click event listener
inlineDeferredIframeWrappers.forEach(function(wrapper) {
    wrapper.addEventListener('click', function() {
        const videoTextContainer = this.querySelector('[data-video-text-container]');

        // Find the template inside the container
        const template = videoTextContainer.querySelector('template');

        // Check if the template exists and contains content
        if (template && template.content) {
            // Clone the content of the template (the iframe)
            const iframe = template.content.querySelector('iframe');

            // Append the iframe directly to the container
            if (iframe) {
                videoTextContainer.appendChild(iframe);
                this.setAttribute('loaded', 'true');
            }
        }
    });
});